import { cx } from "@/utils";

import styles from "./Article.module.css";

type ArticleProps = {
  className?: string;
  content: TrustedHTML;
} & React.HTMLProps<HTMLDivElement>;

/**
 * Syncs the look of our typography with a html blob
 */
const Article: React.FunctionComponent<ArticleProps> = ({
  className,
  content,
  ...props
}) => {
  return (
    <article
      {...props}
      className={cx(styles.root, className)}
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
};

export default Article;
